import { generateId } from "./generate-id";

export const OTP_LENGTH = 8;

/**
 * This function generates a random OTP (One Time Password) of a specified length.
 * The OTP is generated by creating a random uuidv4 and taking the last 8 characters of it and uppercasing it.
 * @returns
 */
export function generateOTP(): string {
	const randomId = generateId();
	const otp = randomId.slice(-OTP_LENGTH);
	return otp.toUpperCase();
}
